<form class="enquiries-form" [formGroup]="form">
  <div class="enquiries-title">{{ 'enquiries.title' | translate }}</div>
  <ng-container *ngIf="!submitted; else submittedTemplate">
    <div class="enquiries-desc text">{{ 'enquiries.description' | translate }}</div>
    <div class="enquiries-input-group">
      <label for="name-input" class="enquiry-label subtitle">{{ 'enquiries.filters.name' | translate }}</label>
      <input id="name-input" type="text" [class]="" pInputText formControlName="name" />
      <ng-container *ngIf="submitIntent">
        <small *ngIf="form.get('name').errors" class="p-error block">{{
          'public.error.provideName' | translate
        }}</small>
      </ng-container>
    </div>
    <div class="enquiries-input-group">
      <label for="surname-input" class="enquiry-label subtitle">{{ 'enquiries.filters.surname' | translate }}</label>
      <input id="surname-input" type="text" [class]="" pInputText formControlName="surname" />
      <ng-container *ngIf="submitIntent">
        <small *ngIf="form.get('surname').errors" class="p-error block">{{
          'public.error.provideSurname' | translate
        }}</small>
      </ng-container>
    </div>
    <div class="enquiries-input-group">
      <label for="company-input" class="enquiry-label subtitle">{{ 'enquiries.filters.company' | translate }}</label>
      <input id="company-input" type="text" pInputText formControlName="company" />
      <ng-container *ngIf="submitIntent">
        <small *ngIf="form.get('company').errors" class="p-error block">{{
          'public.error.provideCompany' | translate
        }}</small>
      </ng-container>
    </div>
    <div class="enquiries-input-group">
      <label for="companyRole-input" class="enquiry-label subtitle">{{
        'enquiries.filters.companyRole' | translate
      }}</label>
      <input id="companyRole-input" type="text" pInputText formControlName="companyRole" />
    </div>
    <div class="enquiries-input-group">
      <label for="email-input" class="enquiry-label subtitle">{{ 'enquiries.filters.email' | translate }}</label>
      <input id="email-input" type="email" pInputText formControlName="email" />
      <ng-container *ngIf="submitIntent">
        <small *ngIf="form.get('email').errors" class="p-error block">{{
          'public.error.provideEmail' | translate
        }}</small>
      </ng-container>
    </div>
    <div class="enquiries-input-group">
      <label for="country-input" class="enquiry-label subtitle">{{ 'enquiries.filters.country' | translate }}</label>
      <p-multiSelect
        id="country-input"
        [virtualScroll]="true"
        [itemSize]="30"
        [options]="countryList"
        optionLabel="name"
        [showToggleAll]="false"
        [defaultLabel]="'public.filters.country.select' | translate"
        class="fix"
        formControlName="country"
      >
      </p-multiSelect>
      <!-- Movie no available for this country at the moment message -->
      <!-- <small *ngIf="countriesNoAvailable" class="p-error block">{{
        'enquiries.filters.countriesNoAvailable' | translate: null:{ movie: movie.title | titlecase, countryList: countriesNoAvailable }
      }}</small> -->
      <ng-container *ngIf="submitIntent">
        <small *ngIf="form.get('country').errors" class="p-error block">{{
          'public.error.provideCountry' | translate
        }}</small>
      </ng-container>
    </div>
    <div class="enquiries-input-group">
      <label for="comments-input" class="enquiry-label subtitle">{{ 'enquiries.filters.comments' | translate }}</label>
      <textarea
        class="text"
        id="comments-input"
        [rows]="5"
        [cols]="30"
        pInputTextarea
        autoResize="autoResize"
        formControlName="comments"
      ></textarea>
    </div>
    <button class="button enquiries-submit" (click)="onSubmit()">
      <ng-container *ngIf="!processingSubmition; else loading">
        <span>{{ 'competition.form.submit' | translate }}</span>
      </ng-container>
    </button>
  </ng-container>
</form>

<!-- TEMPLATES -->

<ng-template #loading>
  <ush-loading-indicator fontSize="30px" height="auto"></ush-loading-indicator>
</ng-template>

<ng-template #submittedTemplate>
  <div class="submitted-msg">Thanks for submitting your query, we will back to you soon.</div>
</ng-template>
